import builtinStrategyContent from "@/mocks/builtin-strategies.json";
import type { Strategy } from "@/mocks/operating-strategy";

// Source: 亚马逊62种广告打法完全解析.md. The source omits 61; preserve its numbering.
export const BUILTIN_STRATEGIES: Strategy[] = builtinStrategyContent.map(
  ({ id, name, goal, description, sections }) => ({
    id,
    name,
    source: "builtin",
    goal,
    updatedAt: "2026-09-24",
    tacticIds: [],
    description,
    sections,
  }),
);
